import { render, staticRenderFns } from "./Cuadrillas.vue?vue&type=template&id=23d59fe0&"
import script from "./Cuadrillas.vue?vue&type=script&lang=js&"
export * from "./Cuadrillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports